<script>
import { ActionBar, ActionBarTitle } from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { back } from '@/utils/navigation'

const Overview = () => import('./Overview')
const Result = () => import('./Result')

export default {
  data() {
    return {
      name: '',
      unit: ''
    }
  },

  methods: {
    dismiss() {
      back({ name: 'Warehouse' })
    },

    filter() {
      this.$refs.result.reset()
      this.$refs.result.fetch()
    }
  },

  render() {
    return (
      <div>
        <ActionBar dismissible onDismiss={this.dismiss}>
          <ActionBarTitle>
            คลังสินค้า ทองขายหน้าร้าน / {this.name}
          </ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Overview
              onSubmit={this.filter}
              onProductLoad={value => {
                this.name = value.name
                this.unit = value.unit ? value.unit.name : null
              }}
            />
            <Result
              ref="result"
              unit={this.unit}
              style={{ marginTop: '1.5rem' }}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
